import ProductCategoryType from './ProductCategoryType';
import ProductType from './ProductType';
import TestimonialType from './TestimonialType';

export { ProductCategoryType, ProductType, TestimonialType };



// WEBPACK FOOTER //
// ./src/types/index.js